module.exports = __webpack_public_path__ + "img/sample.1cf57d4b.png";